import { FloatingArrow, FloatingPortal } from '@floating-ui/react';
import clsx from 'clsx';
import type { CSSProperties, PropsWithChildren, ReactNode } from 'react';

import { isDefined } from '../../../utils/typescript-helpers.ts';
import { useSgTooltipContext } from './SgTooltipContext';

export type SgTooltipContentProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export const SgTooltipContent = (props: PropsWithChildren<SgTooltipContentProps>) => {
  const { children, className, style } = props;

  const { refs, floatingStyles, color, backgroundColor, isOpen, arrow, arrowRef, floatingContext, hide } =
    useSgTooltipContext();

  if (!isOpen) {
    return null;
  }

  return (
    <FloatingPortal>
      <div
        ref={refs.setFloating}
        style={{
          ...floatingStyles,
          ...style,
          zIndex: 1800,
          visibility: hide?.referenceHidden === true ? 'hidden' : 'visible',
          pointerEvents: 'none',
        }}
        className={clsx(className, `text-${color} bg-${backgroundColor}`)}
        data-e2e="tooltip-content"
      >
        {isDefined(arrow) && (
          <FloatingArrow
            ref={arrowRef}
            className="arrow"
            context={floatingContext}
            fill={`var(--bs-${backgroundColor})`}
          />
        )}
        {children}
      </div>
    </FloatingPortal>
  );
};
